import React, { Component } from 'react';
import Konva from 'konva';
import { Stage, Layer, Star, Text, Rect, Circle, Line, Image } from 'react-konva';
import _ from 'lodash';
import TransformerComponent from './TransformerComponent/TransformerComponent';
import Arrows from './Arrow/Arrow';

class Test extends Component {

  state = {
    image: null,
    circleX: null,
    circleY: null,
    rectangles: [],
    selectedShapeName: '',
    color: '',
    getConvasDataArr: [],
    stepFourComplited: false,
    checked: false,
    rectanglesChecked: false
  };

  image = {};

  handleCheckPlace = () => {
    const { getInfluencerMapGroupsData } = this.props;

    getInfluencerMapGroupsData.Items[0].groupsMap.forEach((rect, i) => {
      const isLast = getInfluencerMapGroupsData.Items[0].groupsMap.length - 1 === i;

      this.handleCanvasWidthIndicator(rect.x, rect.width, isLast);
      this.handleCanvasHeightIndicator(rect.y, rect.height, isLast);
    })
  }

  componentDidUpdate() {
    const { checked, rectangles, rectanglesChecked } = this.state;
    const { getInfluencerMapGroupsData } = this.props;

    if (getInfluencerMapGroupsData && getInfluencerMapGroupsData.Items[0].groupsMap && !checked) {
      this.setState({ checked: true });

      this.handleCheckPlace();
    }

    if (getInfluencerMapGroupsData && getInfluencerMapGroupsData.Items[0].groupsMap && rectangles.length > 0 && !rectanglesChecked) {
      this.setState({ rectanglesChecked: true });
      let hasMissingCordinates = false;
      const rectanglesClone = [...rectangles];

      rectanglesClone.forEach((e, idx) => {
        if ((!e.x || !e.y) && e.type === 'Text') {
          const generateXCordinate = this.getRandomCordinateX();
          const generateYCordinate = this.getRandomCordinateY();

          for (let i = 0; i < rectangles.length; i++) {
            if (e.subName === rectangles[i].name || e.subName === rectangles[i].subName) {
              hasMissingCordinates = true;
              const minusXNumber = rectangles[i].type === 'Text' ? 0 : e.width / 2;

              rectanglesClone[i].x = generateXCordinate + minusXNumber;
              rectanglesClone[i].y = generateYCordinate;

              rectanglesClone[idx].x = generateXCordinate + minusXNumber;
              rectanglesClone[idx].y = generateYCordinate;
            }
          }
        }
      })

      if (hasMissingCordinates) {
        this.setState({ rectangles: rectanglesClone }, () => {
          this.handleCheckPlace();
        })
      }
    }
  }

  componentWillMount = () => {
    if (!this.props.getInfluencerMapGroupsData.Items[0].groupsMap) {
      _.map(this.props.getInfluencerMapGroupsData.Items[0].groups, (rect, i) => {
        let groupLevel;
        let circleHeight;
        let circleWidth;

        let notChangingCircleColor;

        let subCircleHeight;
        let subCircleWidth;

        let circleTextWidth;
        let circleTextHeight;

        let circleX;
        let circleY;

        if (i < 5) {
          circleX = i === 0 ? 100 : (i > 1 ? i * 200 : 250);
          circleY = 90;
        } else if (i >= 5 && i < 10) {
          circleX = (i - 5) === 0 ? 100 : ((i - 5) > 1 ? (i - 5) * 200 : 250);
          circleY = 250;
        } else if (i >= 10 && i < 15) {
          circleX = (i - 10) === 0 ? 100 : ((i - 10) > 1 ? (i - 10) * 200 : 250);
          circleY = 400;
        }

        //let circleY = i === 0 ? 100 : (i > 1 ? i * 150 : 200);

        if (rect.level === 'small') {
          circleHeight = 60;
          circleWidth = 60;
          subCircleHeight = 60;
          subCircleWidth = 60;
          groupLevel: 'small';
        } else if (rect.level === 'medium') {
          circleHeight = 100;
          circleWidth = 100;
          subCircleHeight = 100;
          subCircleWidth = 100;
          groupLevel: 'medium';
        } else if (rect.level === 'large') {
          circleHeight = 160;
          circleWidth = 160;
          subCircleHeight = 160;
          subCircleWidth = 160;
          groupLevel: 'large';
        }

        if (rect.influenceChange === 'growing') {
          circleHeight = circleHeight + 30;
          circleWidth = circleWidth + 30;
          notChangingCircleColor = 'red'
        } else if (rect.influenceChange === 'shrinking') {
          subCircleHeight = subCircleHeight + 30;
          subCircleWidth = subCircleWidth + 30;
          notChangingCircleColor = 'red'
        } else if (rect.influenceChange === 'notChanging') {
          notChangingCircleColor = 'black'
        }

        let circleName = (this.state.rectangles.length + 1).toString();
        let subCircleName = (+circleName + 1).toString();
        let textName = (+circleName + 2).toString();
        let subCircleParentName = circleName

        let textWidth = circleWidth > subCircleWidth ? circleWidth : subCircleWidth
        let textX = circleX - (textWidth / 2);

        let data = [
          {
            dash: [20, 20],
            draggable: true,
            fill: undefined,
            groupId: rect.groupId,
            height: circleHeight,
            name: circleName,
            offset: 3,
            pointerAtBeginning: undefined,
            pointerLength: undefined,
            pointerWidth: undefined,
            points: undefined,
            rotation: 0,
            scaleX: 1,
            scaleY: 1,
            stroke: notChangingCircleColor,
            strokeWidth: 4,
            subtype: undefined,
            type: "Circle",
            width: circleWidth,
            x: circleX,
            y: circleY,
            id: rect.groupId,
            groupLevel: groupLevel,
          },
          {
            dash: undefined,
            draggable: true,
            fill: "#ccc",
            groupId: rect.groupId,
            stroke: "black",
            strokeWidth: 4,
            height: subCircleHeight,
            offset: 3,
            pointerAtBeginning: undefined,
            pointerLength: undefined,
            pointerWidth: undefined,
            points: undefined,
            rotation: undefined,
            subtype: "circle",
            subName: subCircleParentName,
            name: subCircleName,
            type: "Circle",
            width: subCircleWidth,
            x: circleX,
            y: circleY,
            scaleX: 1,
            scaleY: 1,
            id: rect.groupId,
          },
          {
            dash: undefined,
            draggable: false,
            fill: undefined,
            groupId: rect.groupId,
            height: undefined,
            name: textName,
            pointerAtBeginning: undefined,
            pointerLength: undefined,
            pointerWidth: undefined,
            points: undefined,
            rotation: undefined,
            stroke: undefined,
            strokeWidth: undefined,
            subtype: "text",
            subName: subCircleParentName,
            type: "Text",
            width: textWidth,
            x: textX,
            y: circleY,
            id: rect.groupId,
            text: rect.groupName
          }
        ]
        this.state.rectangles.push(data[0])
        this.state.rectangles.push(data[1])
        this.state.rectangles.push(data[2])
      })
    }

    if (this.props.getInfluencerMapGroupsData.Items[0].groupsMap) {

      let textNumberArr = [];
      _.map(this.props.getInfluencerMapGroupsData.Items[0].groupsMap, (rect, i) => {
        if (rect.type === 'Text') {
          textNumberArr.push(rect);
        }
      })

      if (textNumberArr.length === this.props.getInfluencerMapGroupsData.Items[0].groups.length) {
        _.map(this.props.getInfluencerMapGroupsData.Items[0].groupsMap, (rect, i) => {

          this.state.rectangles.push(rect);
        })
      } else if (textNumberArr.length < this.props.getInfluencerMapGroupsData.Items[0].groups.length) {
        _.map(this.props.getInfluencerMapGroupsData.Items[0].groupsMap, (rect, i) => {
          this.state.rectangles.push(rect);
        });

        let newData = [];
        for (let rect of this.props.getInfluencerMapGroupsData.Items[0].groups) {
          if (!(this.props.getInfluencerMapGroupsData.Items[0].groupsMap.find(r => r.text === rect.groupName))) {
            newData.push(rect)
          }
          ;
        }

        if (!_.isEmpty(newData)) {

          _.map(newData, (rect, i) => {

            let groupLevel;
            let circleHeight;
            let circleWidth;
            let notChangingCircleColor;

            let subCircleHeight;
            let subCircleWidth;

            let circleX = i === 0 ? 100 : (i > 1 ? i * 150 : 200);
            let circleY = i === 0 ? 100 : (i > 1 ? i * 150 : 200);

            if (rect.level === 'small') {
              circleHeight = 60;
              circleWidth = 60;
              subCircleHeight = 60;
              subCircleWidth = 60;
              groupLevel: 'small';
            } else if (rect.level === 'medium') {
              circleHeight = 100;
              circleWidth = 100;
              subCircleHeight = 100;
              subCircleWidth = 100;
              groupLevel: 'medium';
            } else if (rect.level === 'large') {
              circleHeight = 160;
              circleWidth = 160;
              subCircleHeight = 160;
              subCircleWidth = 160;
              groupLevel: 'large';
            }

            if (rect.influenceChange === 'growing') {
              circleHeight = circleHeight + 30;
              circleWidth = circleWidth + 30;
              notChangingCircleColor = 'red'
            } else if (rect.influenceChange === 'shrinking') {
              subCircleHeight = subCircleHeight + 30;
              subCircleWidth = subCircleWidth + 30;
              notChangingCircleColor = 'red'
            } else if (rect.influenceChange === 'notChanging') {
              notChangingCircleColor = 'black'
            }


            let findLargestName = [];
            _.map(this.state.rectangles, (rect, i) => {
              if (rect.name) {
                return findLargestName.push(+rect.name)
              }
            });

            let lastElement = 0;

            if (findLargestName && findLargestName.length > 0) {
              lastElement = Math.max.apply(Math, findLargestName);
            }

            let circleName = (+lastElement + 1).toString();
            let subCircleName = (+circleName + 1).toString();
            let textName = (+circleName + 2).toString();
            let subCircleParentName = circleName

            let textWidth = circleWidth > subCircleWidth ? circleWidth : subCircleWidth
            let textX = circleX - (textWidth / 2);

            let data = [
              {
                dash: [20, 20],
                draggable: true,
                fill: undefined,
                height: circleHeight,
                name: circleName,
                offset: 3,
                pointerAtBeginning: undefined,
                pointerLength: undefined,
                pointerWidth: undefined,
                points: undefined,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                stroke: notChangingCircleColor,
                strokeWidth: 4,
                subtype: undefined,
                type: "Circle",
                width: circleWidth,
                x: circleX,
                y: circleY,
                id: rect.groupId,
                groupLevel: groupLevel,
              },
              {
                dash: undefined,
                draggable: true,
                fill: "#ccc",
                stroke: "black",
                strokeWidth: 4,
                height: subCircleHeight,
                name: subCircleName,
                offset: 3,
                pointerAtBeginning: undefined,
                pointerLength: undefined,
                pointerWidth: undefined,
                points: undefined,
                rotation: undefined,
                subtype: "circle",
                subName: subCircleParentName,
                type: "Circle",
                width: subCircleWidth,
                x: circleX,
                y: circleY,
                scaleX: 1,
                scaleY: 1,
                id: rect.groupId,
              },
              {
                dash: undefined,
                draggable: false,
                fill: undefined,
                height: undefined,
                name: textName,
                pointerAtBeginning: undefined,
                pointerLength: undefined,
                pointerWidth: undefined,
                points: undefined,
                rotation: undefined,
                stroke: undefined,
                strokeWidth: undefined,
                subtype: "text",
                subName: subCircleParentName,
                type: "Text",
                width: textWidth,
                x: textX,
                y: circleY,
                id: rect.groupId,
                text: rect.groupName
              }
            ]
            this.state.rectangles.push(data[0])
            this.state.rectangles.push(data[1])
            this.state.rectangles.push(data[2])
          });
        }
      } else if (textNumberArr.length > this.props.getInfluencerMapGroupsData.Items[0].groups.length) {

        _.map(this.props.getInfluencerMapGroupsData.Items[0].groupsMap, (rect, i) => {
          this.state.rectangles.push(rect);
        });

        let deletedData = [];
        for (let rect of this.props.getInfluencerMapGroupsData.Items[0].groupsMap) {
          if (rect.text && !(this.props.getInfluencerMapGroupsData.Items[0].groups.find(r => (r.groupName === rect.text)))) {
            deletedData.push(rect)
          }
          ;
        }

        if (!_.isEmpty(deletedData)) {
          _.map(deletedData, (rect, i) => {
            _.remove(this.state.rectangles, (comment) => {
              return (comment.name === rect.name || comment.name === rect.subName || comment.subName === rect.subName)
            });
          })
        }
      }

      for (let rect of this.props.getInfluencerMapGroupsData.Items[0].groups) {

        let changedData = this.state.rectangles.find(r => r.id === rect.groupId && !r.subName);
        let changedDataChild = changedData ? this.state.rectangles.find(r => r.subName === changedData.name && r.type === "Circle") : null;

        if (changedData) {
          if (rect.level === 'small' && changedData.width >= 100) {
            changedData.width = 60;
            changedData.height = 60;
            changedDataChild.width = 60;
            changedDataChild.height = 60;
            changedDataChild.scaleX = 1;
            changedDataChild.scaleY = 1;
            changedData.scaleX = 1;
            changedData.scaleY = 1;

          } else if (rect.level === 'medium' && changedData.width >= 160) {
            changedData.width = 100;
            changedData.height = 100;
            changedDataChild.width = 100;
            changedDataChild.height = 100;

          } else if (rect.level === 'large' && changedData.width < 159) {
            changedData.width = 160;
            changedData.height = 160;
            changedDataChild.width = 160;
            changedDataChild.height = 160;
          }
          if (rect.influenceChange === 'growing' && !(changedData.width > changedDataChild.width)) {
            changedData.width = changedDataChild.width + 30;
            changedData.height = changedDataChild.height + 30;
            changedDataChild.scaleX = 1;
            changedDataChild.scaleY = 1;
            changedData.scaleX = 1;
            changedData.scaleY = 1;
            changedData.stroke = 'red'
            //changedDataChild.stroke = 'red'
          } else if (rect.influenceChange === 'shrinking' && !(changedData.width < changedDataChild.width)) {
            changedDataChild.height = (changedData.width * changedData.scaleX) + 30;
            changedDataChild.width = (changedData.height * changedData.scaleY) + 30;
            changedDataChild.scaleX = 1;
            changedDataChild.scaleY = 1;
            changedData.scaleX = 1;
            changedData.scaleY = 1;
            changedData.notChangingCircleColor = 'red'

          } else if (rect.influenceChange === 'notChanging' && !(changedData.width === changedDataChild.width)) {

            changedData.height = changedDataChild.height;
            changedData.width = changedDataChild.width;
            changedData.scaleX = changedDataChild.scaleX;
            changedData.scaleY = changedDataChild.scaleY;
            changedDataChild.scaleX = 1;
            changedDataChild.scaleY = 1;
            changedData.scaleX = 1;
            changedData.scaleY = 1;
            changedData.notChangingCircleColor = 'black'

          }
        }
      }
    }

  }

  componentDidMount() {
    this.orderItems();
    window.addEventListener('keydown', this.keyboardHandler);
  }

  keyboardHandler = e => {
    if (e.code === 'Backspace' && this.state.selectedShapeName) {
      const arrowElement = this.state.rectangles.find(r => r.name === this.state.selectedShapeName);

      if (arrowElement.type === 'Arrow') {
        const rectanglesData = [...this.state.rectangles];
        _.remove(rectanglesData, (comment) => {
          return comment.name === this.state.selectedShapeName
        });
        this.setState({ rectangles: rectanglesData });
      }
    }
  }

  orderItems = () => {
    for (let rect of this.state.rectangles) {
      if (!rect.subName && rect.type === 'Circle') {
        const name = (+(rect.name) + 1).toString();
        let childElement = _.find(this.state.rectangles, (i) => i.name === name)
        let childElementWidth = childElement.scaleX * childElement.width;
        let parentElementWidth = rect.scaleX * rect.width;
        if (childElementWidth > parentElementWidth) {
          this[`${name}`].setZIndex(3);
          this[`${rect.name}`].setZIndex(10);
          this[`${rect.name}`].setStroke('red');
        }
        // if (childElementWidth === parentElementWidth) {
        //   this[`${name}`].setZIndex(3);
        //   this[`${rect.name}`].setZIndex(5);
        //   this[`${rect.name}`].setStroke('black');
        // }
      }
    }
  }

  handleLoad = (item) => {
    let state = { ...this.state };
    state[item] = this.image[item];
    this.setState(state);
  };

  componentWillReceiveProps(nextProps) {
    //takeOffHighLightState
    // if ((this.state.selectedShapeName !== '') && (this.props.color !== nextProps.color)) {
    if ((this.state.selectedShapeName !== '' && nextProps.changeColorState && this.props.changeColorState !== nextProps.changeColorState)) {
      const state = { ...this.state };
      this.props.colorChanged();
      state.rectangles.map((o, i) => {
        if ((o.name === this.state.selectedShapeName) && !((o.type === 'Circle') && o.stroke === 'red')) {
          o.fill = nextProps.color
        }
        if ((o.name === this.state.selectedShapeName) && ((o.type === 'Circle') && o.stroke === 'red')) {
          let changedCircle = this.state.rectangles.find(r => r.subName === o.name && r.type === 'Circle');
          if (changedCircle) {
            changedCircle.fill = nextProps.color
          }
        }
      });
    }

    // Arrow
    if (nextProps.arrowType !== '') {

      this.props.createdArrow();
      const state = { ...this.state };

      let findLargestName = [];
      _.map(this.state.rectangles, (rect, i) => {
        if (rect.name) {
          return findLargestName.push(+rect.name)
        }
      });

      let lastElement = 0;

      if (findLargestName && findLargestName.length > 0) {
        lastElement = Math.max.apply(Math, findLargestName)
      }

      let name = (+lastElement + 1).toString();
      let subCircleName = (+name + 1).toString();
      const oldArrow = this.state.rectangles.find(r => r.subType === nextProps.arrowType);

      let x = oldArrow ? oldArrow.x + 20 : 300;
      let y = oldArrow ? oldArrow.y + 20 : 200;

      let points = [10, 80, 200, 80];
      let hasCoordinates = true;

      if (this.transformerRef && this.transformerRef._nodes && this.transformerRef._nodes.length === 2) {
        const node1 = this.transformerRef._nodes[0].attrs;
        const node2 = this.transformerRef._nodes[1].attrs;

        const node1Radius = this.transformerRef._nodes[0].getWidth() / 2;
        const node2Radius = this.transformerRef._nodes[1].getWidth() / 2;

        hasCoordinates = false;

        const dx = node1.x - node2.x;
        const dy = node1.y - node2.y;
        let angle = Math.atan2(-dy, dx);

        // const radius = 30;

        const arrowStart = {
          x: node2.x + -node2Radius * Math.cos(angle + Math.PI),
          y: node2.y + node2Radius * Math.sin(angle + Math.PI)
        };

        const arrowEnd = {
          x: node1.x + -node1Radius * Math.cos(angle),
          y: node1.y + node1Radius * Math.sin(angle)
        };

        points = [
          arrowStart.x,
          arrowStart.y,
          arrowEnd.x,
          arrowEnd.y
        ]
      }

      if (nextProps.arrowType === 'arrowRight') {

        let newData = [
          {
            x: x,
            y: y,
            width: 200,
            height: 80,
            name: name,
            type: 'Arrow',
            subType: 'arrowRight',
            offset: 3,
            fill: 'black',
            points: points,
            pointerLength: 20,
            pointerWidth: 20,
            stroke: 'black',
            strokeWidth: 2,
            dash: [0, 0],
            scaleX: 1,
            scaleY: 1,
            pointerAtBeginning: false
          },

        ]

        if (!hasCoordinates) {
          delete newData[0].x;
          delete newData[0].y;
        }

        this.state.rectangles.push(newData[0])
        //this.state.rectangles.push(newData[1])
        //this.state.rectangles.push(newData);

      }

      if (nextProps.arrowType === 'arrowAtBeginning') {
        let newData = {
          x: x,
          y: y,
          width: 200,
          height: 80,
          name: name,
          type: 'Arrow',
          subType: 'arrowAtBeginning',
          fill: 'black',
          points: points,
          pointerLength: 20,
          pointerWidth: 20,
          stroke: 'black',
          strokeWidth: 2,
          dash: [0, 0],
          scaleX: 1,
          scaleY: 1,
          pointerAtBeginning: true
        }

        if (!hasCoordinates) {
          delete newData.x;
          delete newData.y;
        }
        this.state.rectangles.push(newData)
      }

      if (nextProps.arrowType === 'arrowRightDash') {
        let newData = {
          x: x,
          y: y,
          width: 200,
          height: 80,
          name: name,
          type: 'Arrow',
          subType: 'arrowRightDash',
          fill: 'black',
          points: points,
          pointerLength: 20,
          pointerWidth: 20,
          stroke: 'black',
          strokeWidth: 2,
          dash: [10, 10],
          scaleX: 1,
          scaleY: 1,
          pointerAtBeginning: false
        }

        if (!hasCoordinates) {
          delete newData.x;
          delete newData.y;
        }
        this.state.rectangles.push(newData)
      }

      if (nextProps.arrowType === 'arrowAtBeginningDash') {
        let newData = {
          x: x,
          y: y,
          width: 200,
          height: 80,
          name: name,
          type: 'Arrow',
          subType: 'arrowAtBeginningDash',
          fill: 'black',
          points: points,
          pointerLength: 20,
          pointerWidth: 20,
          stroke: 'black',
          strokeWidth: 2,
          dash: [10, 10],
          pointerAtBeginning: true
        }

        if (!hasCoordinates) {
          delete newData.x;
          delete newData.y;
        }

        this.state.rectangles.push(newData)
      }
    }

    if ((this.state.selectedShapeName !== '') && nextProps.deleteElementState) {
      this.props.deleteElement('deleted');

      const arrowElement = this.state.rectangles.find(r => r.name === this.state.selectedShapeName);

      if (arrowElement.type === 'Arrow') {
        _.remove(this.state.rectangles, (comment) => {
          return comment.name === this.state.selectedShapeName
        });
      }
    }

    if ((this.state.selectedShapeName === '') && nextProps.deleteElementState) {
      this.props.deleteElement('deleted');
    }

    if ((this.state.selectedShapeName !== '') && (this.props.arrowPlus !== nextProps.arrowPlus)) {
      const state = { ...this.state };
      state.rectangles.map((o, i) => {
        if ((o.name === this.state.selectedShapeName) && !(o.type === 'Circle')) {
          o.strokeWidth = nextProps.arrowPlus
        }
      })
    }

    if ((nextProps.getCanvasData && _.isEmpty(this.state.getConvasDataArr)) || (nextProps.getCanvasDataForBackStep && _.isEmpty(this.state.getConvasDataArr)) && !this.state.stepFourComplited) {
      this.setState({ stepFourComplited: true })
      let data = this.layer.getChildren();
      let canvasData = _.map(data, (rect, i) => {

        let width;
        let height;
        let groupId;

        const selectedRectangle = _.find(this.state.rectangles, e => e.name === rect.attrs.name);

        if (selectedRectangle && selectedRectangle.groupId) {
          groupId = selectedRectangle.groupId;
        }

        if (rect.attrs === 'Circle') {
          if (rect.attrs.groupLevel === 'small') {
            width = rect.attrs.scaleX * 80;
            height = rect.attrs.scaleX * 80;

          } else if (rect.attrs.groupLevel === 'medium') {
            width = rect.attrs.scaleX * 120;
            height = rect.attrs.scaleX * 120;
          } else if (rect.attrs.groupLevel === 'large') {
            width = rect.attrs.scaleX * 200;
            height = rect.attrs.scaleX * 200;
          }
        } else {
          width = rect.getWidth();
          height = rect.getHeight();
        }

        return (
          {
            x: rect.attrs.x || 0,
            y: rect.attrs.y || 0,
            scaleX: rect.attrs.scaleX,
            scaleY: rect.attrs.scaleY,
            // width: rect.attrs.width * rect.attrs.scaleX,
            // height: rect.attrs.height * rect.attrs.scaleY,
            width: width,
            height: height,
            fill: rect.attrs.fill,
            name: rect.attrs.name,
            groupId,
            type: rect.className,
            subtype: rect.attrs.subtype,
            subName: rect.attrs.subName,
            dash: rect.attrs.dash,
            rotation: rect.attrs.rotation,
            offset: 3,
            stroke: rect.attrs.stroke,
            strokeWidth: rect.attrs.strokeWidth,
            draggable: rect.attrs.draggable,
            points: rect.attrs.points,
            pointerLength: rect.attrs.pointerLength,
            pointerWidth: rect.attrs.pointerWidth,
            pointerAtBeginning: rect.attrs.pointerAtBeginning,
            text: rect.attrs.text,
            id: rect.attrs.id,
            groupLevel: rect.attrs.groupLevel,
          }
        )
      })

      if (nextProps.getCanvasData) {
        this.props.stepFourData(canvasData);
      }
      if (nextProps.getCanvasDataForBackStep) {
        this.props.backFromStepFour(canvasData)
      }
    }
  }

  handleStageMouseDown = e => {
    // clicked on stage - cler selection
    if (e.target === e.target.getStage()) {
      this.setState({
        selectedShapeName: '',
        color: ''
      });
      return;
    }

    if (e.target.className !== 'Line' && e.target.className !== 'Image') {
      const name = e.target.name();
      let rect = this.state.rectangles.find(r => r.name === name);

      if (this.state.selectedShapeName && e.evt.shiftKey && rect && rect.type !== 'Text') {
        const selectedNode = this.stage.findOne('.' + this.state.selectedShapeName);
        const nowClickedNode = this.stage.findOne('.' + name);


        this.transformerRef.nodes([nowClickedNode, selectedNode]);
        return this.transformerRef.getLayer().batchDraw();


        // let newData = {
        //   name: (this.state.rectangles.length + 1).toString(),
        //   type: 'Arrow',
        //   subType: 'arrowRight',
        //   offset: 3,
        //   fill: 'black',
        //   points: [
        //     arrowStart.x,
        //     arrowStart.y,
        //     arrowCurve.x,
        //     arrowCurve.y,
        //     arrowEnd.x,
        //     arrowEnd.y
        //   ],
        //   pointerLength: 20,
        //   pointerWidth: 20,
        //   stroke: 'black',
        //   strokeWidth: 2,
        //   dash: [0, 0],
        //   scaleX: 1,
        //   scaleY: 1,
        //   pointerAtBeginning: false
        // }

        // return this.setState({
        //   rectangles: [...this.state.rectangles, newData]
        // })
      }

      if (rect && rect.type !== 'Text') {
        this.setState({
          selectedShapeName: name,
        }, () => {
          const state = { ...this.state };
          state.rectangles.map((o, i) => {
            if (o.name === this.state.selectedShapeName) {
              this.props.defaultSize(o.strokeWidth);
            }
          })
        });
      }
    }

  };

  adjustPoint = (e) => {
    const x = e.target.attrs.x;
    const y = e.target.attrs.y;
    const width = e.target.getWidth();
    const height = e.target.getHeight();
    this.handleCanvasWidthIndicator(x, width, true);
    this.handleCanvasHeightIndicator(y, height, true);
    if (e.target.className === "Circle") {
      const parentElement = this.state.rectangles.find(r => r.name === e.target.attrs.name);

      if (!parentElement.subName) {
        let childElemnt = (+(parentElement.name) + 1).toString();
        let textElement = (+(parentElement.name) + 2).toString();
        if (e.target.className === 'Circle') {
          this[`${childElemnt}`].setX(e.target.getX());
          this[`${childElemnt}`].setY(e.target.getY());
          // console.log('this child circle', this[`${childElemnt}`])
          // console.log('getX circle', e.target.getX())
          // console.log(' child elem circle', childElemnt)
          this[`${textElement}`].setX((e.target.getX()) - (this[`${textElement}`].getWidth() / 2));
          this[`${textElement}`].setY(e.target.getY() - 5);
        }
      }

      if (parentElement.subName) {
        let childElemnt = (+(parentElement.name) - 1).toString();
        let textElement = (+(parentElement.name) + 1).toString();
        if (e.target.className === 'Circle') {
          this[`${childElemnt}`].setX(e.target.getX());
          this[`${childElemnt}`].setY(e.target.getY());
          this[`${textElement}`].setX((e.target.getX()) - (this[`${textElement}`].getWidth() / 2));
          this[`${textElement}`].setY(e.target.getY() - 5);
        }
      }
    }
  }

  setTransformerRef = (input) => {
    this.transformerRef = input;
  }

  transformAdjustPoint = (e) => {
    if (e.currentTarget.className === 'Circle') {
      const parentElement = this.state.rectangles.find(r => r.name === e.currentTarget.attrs.name);
      if (!parentElement.subName) {
        let childElemnt = (+(parentElement.name) + 1).toString();
        let textElement = (+(parentElement.name) + 2).toString();

        if (e.currentTarget.className === 'Circle') {
          this[`${childElemnt}`].setX(e.currentTarget.getX());
          this[`${childElemnt}`].setY(e.currentTarget.getY());

          this[`${textElement}`].setX((e.currentTarget.getX()) - (this[`${textElement}`].getWidth() / 2));
          this[`${textElement}`].setY(e.currentTarget.getY() - 5);

          let childElementWidth = this[`${childElemnt}`].attrs.scaleX * this[`${childElemnt}`].getWidth();
          let parentElementWidth = this[`${+parentElement.name}`].attrs.scaleX * this[`${+parentElement.name}`].getWidth()

          if ((+parentElementWidth.toString().split(".")[0] - 5 >= +childElementWidth.toString().split(".")[0]) || (+childElementWidth.toString().split(".")[0] >= +parentElementWidth.toString().split(".")[0] + 5)) {
            this[`${+parentElement.name}`].setStroke('red')
          } else {
            this[`${+parentElement.name}`].setStroke('black')
          }
        }
      }

      if (parentElement.subName) {
        let childElemnt = (+(parentElement.name) - 1).toString();
        let textElement = (+(parentElement.name) + 1).toString();
        if (e.currentTarget.className === 'Circle') {
          this[`${childElemnt}`].setX(e.currentTarget.getX());
          this[`${childElemnt}`].setY(e.currentTarget.getY());
          this[`${textElement}`].setX((e.currentTarget.getX()) - (this[`${textElement}`].getWidth() / 2));
          this[`${textElement}`].setY(e.currentTarget.getY() - 5);
        }

        let childElementWidth = this[`${childElemnt}`].attrs.scaleX * this[`${childElemnt}`].getWidth();
        let parentElementWidth = this[`${+parentElement.name}`].attrs.scaleX * this[`${+parentElement.name}`].getWidth()

        if ((+parentElementWidth.toString().split(".")[0] - 5 >= +childElementWidth.toString().split(".")[0]) || (+childElementWidth.toString().split(".")[0] >= +parentElementWidth.toString().split(".")[0] + 5)) {
          this[`${childElemnt}`].setStroke('red')
        } else {
          this[`${childElemnt}`].setStroke('black')
        }
      }

      this.layer.draw();
    }
  }

  valueArray = [];
  valueArrayHeight = [];

  handleCanvasHeightIndicator = (y, height, isLast) => {
    this.valueArrayHeight.push(y + height);

    if (isLast) {
      const { canvasHeight, handleCanvasHeightChange, handleResetCanvasHeight } = this.props;
      this.valueArrayHeight = this.valueArrayHeight.filter(x => !!x);
      if (Math.max(...this.valueArrayHeight) > canvasHeight) {
        handleCanvasHeightChange(Math.max(...this.valueArrayHeight));
        return this.valueArrayHeight = [];
      }
    }
  }

  getRandomCordinateX = () => {
    return Math.random() * (1600 - 100) + 100;
  }

  getRandomCordinateY = () => {
    return Math.random() * (700 - 100) + 100;
  }

  handleCanvasWidthIndicator = (x, width, isLast) => {
    if (document.getElementById('banner-contenedor')) {
      this.valueArray.push(x + width);

      if (isLast) {
        const { convaWidth, setCanvasWidth, handleResetCanvasWidth } = this.props;
        this.valueArray = this.valueArray.filter(x => !!x);

        if (Math.max(...this.valueArray) > convaWidth) {
          setCanvasWidth(Math.max(...this.valueArray));
          return this.valueArray = [];
        }
      }
    }
  }

  render() {
    console.log(this.state.rectangles)
    let rounds = _.map(this.state.rectangles, (rect, i) => {
      if (rect.type === 'Circle') {
        return (
          <Circle
            key={i}
            ref={rect.subName ? ref => this[`${rect.name}`] = ref : ref => this[`${rect.name}`] = ref}
            x={rect.x}
            y={rect.y}
            scaleX={rect.scaleX}
            scaleY={rect.scaleY}
            width={rect.width || 100}
            height={rect.height || 100}
            fill={rect.fill}
            name={rect.name}
            type={rect.type}
            subtype={rect.subtype}
            subName={rect.subName}
            stroke={rect.stroke}
            strokeWidth={rect.strokeWidth}
            draggable={rect.draggable}
            dash={rect.dash}
            resizeEnabled={true}
            onTransform={this.transformAdjustPoint}
            context={rect.context}
            id={rect.id}
            groupLevel={rect.groupLevel}
          />
        )
      }
    });

    let arrow = _.map(this.state.rectangles, (rect, i) => {
      if (rect.type === 'Arrow') {
        return (
          <Arrows
            ref='rect'
            key={i}
            rect={rect}
          />
        )
      }

    });

    let image = _.map(this.state.rectangles, (rect, i) => {
      if (rect.type === 'Image') {

        return (
          <Image
            ref={rect.subName ? ref => this[`${rect.name}`] = ref : ref => this[`${rect.name}`] = ref}
            image={this.state['1']}
            //onDragMove={this.updateLine}
            draggable
            name={rect.name}
            width={rect.width}
            height={rect.height}
            x={rect.x}
            y={rect.y}
            scaleX={rect.scaleX}
            scaleY={rect.scaleY}
            subName={rect.subName}
            subType={rect.subType}
          />
        )
      }

    });

    let circleTexts = _.map(this.state.rectangles, (rect, i) => {
      if (rect.type === 'Text') {
        return (
          <Text
            key={i}
            ref={ref => this[`${rect.name}`] = ref}
            x={rect.x}
            y={rect.y}
            scaleX={rect.scaleX}
            scaleY={rect.scaleY}
            width={rect.width}
            height={rect.height}
            fill={rect.fill}
            name={rect.name}
            type={rect.type}
            subtype={rect.subtype}
            subName={rect.subName}
            stroke={rect.stroke}
            strokeWidth={rect.strokeWidth}
            draggable={rect.draggable}
            dash={rect.dash}
            resizeEnabled={true}
            onTransform={this.transformAdjustPoint}
            text={rect.text}
            fontSize={15}
            align="center"
            fontFamily='Calibri'

          />
        )
      }

    });

    if (this.layer && this.layer.children && this.layer.children.length > 0) {
      this.layer.children.map(children => {
        if (children.className === 'Circle') {
          if (children.attrs.stroke === 'red') {
            children.setZIndex(10);
            this.layer.draw();
          }
        }
        if (children.className === 'Image') {
          children.setZIndex(10);
          this.layer.draw();
        }
      })
    }

    return (
      <Stage
        width={this.props.convaWidth}
        height={this.props.canvasHeight}
        ref={ref => this.stage = ref}
        onDragStart={this.onDragStart}
        onMouseDown={this.handleStageMouseDown}
        onDragMove={this.adjustPoint}
      >
        <Layer ref={ref => this.layer = ref}>
          {rounds}
          {circleTexts}
          {arrow}
          {image}
          <TransformerComponent
            selectedShapeName={this.state.selectedShapeName}
            setRef={this.setTransformerRef}
          />
        </Layer>
      </Stage>
    );
  }
}

export default (Test);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/CustomerInfluencerMap/CustomerInfluencerMapCanvasRounds/CustomerInfluencerMapCanvasRounds.jsx